var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvertDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7343_56280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75632 5.16184H1.53253C0.686139 5.16184 0 5.81528 0 6.62134V7.45535C0 8.26141 0.68614 8.91485 1.53254 8.91485H1.83904V12.0424C1.83904 12.8484 2.52518 13.5019 3.37158 13.5019C4.21797 13.5019 4.90411 12.8484 4.90411 12.0424V9.51422L7.03025 10.3052L1.75632 5.16184Z",
    fill: "#8FBCF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5242 11.5613L3.77732 4.9815L10.1701 2.6033C11.1751 2.22945 12.2603 2.93527 12.2603 3.96277V10.1138C12.2603 11.0211 11.4141 11.6776 10.5242 11.5613Z",
    fill: "#8FBCF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.718 7.10187C12.718 6.7705 12.9935 6.50187 13.3334 6.50187H15.3847C15.7245 6.50187 16 6.7705 16 7.10187C16 7.43324 15.7245 7.70187 15.3847 7.70187H13.3334C12.9935 7.70187 12.718 7.43324 12.718 7.10187Z",
    fill: "#8FBCF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1633 4.08224C12.8689 4.24793 12.7681 4.61488 12.938 4.90186C13.108 5.18883 13.4843 5.28716 13.7787 5.12147L15.5551 4.12147C15.8495 3.95579 15.9503 3.58883 15.7804 3.30186C15.6105 3.01488 15.2341 2.91656 14.9398 3.08224L13.1633 4.08224Z",
    fill: "#8FBCF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9379 9.30176C13.1078 9.01478 13.4842 8.91646 13.7785 9.08214L15.555 10.0821C15.8493 10.2478 15.9502 10.6148 15.7802 10.9018C15.6103 11.1887 15.2339 11.2871 14.9396 11.1214L13.1631 10.1214C12.8688 9.95569 12.7679 9.58874 12.9379 9.30176Z",
    fill: "#8FBCF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.338314 1.48421C0.103999 1.71852 0.103999 2.09842 0.338314 2.33274L12.3383 14.3327C12.5726 14.5671 12.9525 14.5671 13.1868 14.3327C13.4212 14.0984 13.4212 13.7185 13.1868 13.4842L1.18684 1.48421C0.952527 1.24989 0.572629 1.24989 0.338314 1.48421Z",
    fill: "#8FBCF1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7343_56280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.00183105)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertDisable);
export default __webpack_public_path__ + "static/media/advertDisable.eb4b68cef66043454a19cdeb8f843023.svg";
export { ForwardRef as ReactComponent };